import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GetTeamResponse, TeamStudent } from '../../../apis/api.egg'
import { useTeam } from '../Context/TeamContext'
import { StudentItem, TeamListHeader } from './StudentItem/StudentItem'
import styles from './TeamItem.module.css'
import TeamMeet from './TeamMeet'

export const TeamItem = ({ team, isExpanded }: TeamItemProps) => {
    const [listExpanded, setListExpanded] = useState(!!isExpanded)
    const toggleExpand = () => setListExpanded((prev) => !prev)

    return (
        <div className="table-item">
            <TeamMeet {...team} toggleExpand={toggleExpand} isExpanded={listExpanded} />
            {/* {listExpanded && <StudentList teamNumber={team.number} />} */}
        </div>
    )
}

export const StudentList = ({
    teamNumber,
    students,
}: {
    teamNumber: number
    students: TeamStudent[]
}) => {
    const { t } = useTranslation('teamManager')
    const { team } = useTeam()

    if (!students) {
        return (
            <div className="empty-message" style={{ textAlign: 'center', paddingBottom: '30px' }}>
                <p>{t('empty.empty-team')}</p>
            </div>
        )
    }

    return (
        <div className={styles.userList}>
            <TeamListHeader teamNumber={teamNumber} />
            {students.map((student, index) => {
                return (
                    <StudentItem
                        key={index + student._profileId}
                        {...student}
                        team={{
                            number: teamNumber,
                            position: index + 1,
                            algorithmType: team?.algorithm?.algorithmType ?? 'default',
                        }}
                        available
                        algorithmType={team?.algorithm?.algorithmType ?? 'default'}
                    />
                )
            })}
        </div>
    )
}

// Interfaces
interface TeamItemProps {
    team: GetTeamResponse['data']['teams'][0]
    isExpanded?: boolean
}
